import { useState, useEffect } from 'preact/hooks'

export function useTimer(initialMinutes?: number) {
  const [timeLeft, setTimeLeft] = useState<number | null>(null)

  useEffect(() => {
    if (initialMinutes === undefined || initialMinutes === null) {
      setTimeLeft(null)
      return
    }

    setTimeLeft(initialMinutes * 60)
  }, [initialMinutes])

  useEffect(() => {
    if (timeLeft === null || timeLeft <= 0) return

    const interval = setInterval(() => {
      setTimeLeft(prev => (prev !== null ? Math.max(0, prev - 1) : null))
    }, 1000)

    return () => clearInterval(interval)
  }, [timeLeft])

  const formatTime = (totalSeconds: number | null): string => {
    if (totalSeconds === null) return '00:00'
    const minutes = Math.floor(totalSeconds / 60)
    const secs = totalSeconds % 60
    return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
  }

  return {
    timeLeft,
    formattedTime: formatTime(timeLeft),
    isExpired: timeLeft === 0,
    reset: () => {
      if (initialMinutes !== undefined) {
        setTimeLeft(initialMinutes * 60)
      }
    },
  }
}
